import { reactive } from 'vue';

export const criarEpProcItem = () => {
    return reactive({
        id: 0,
        idepproc: 0,
        idepdocmodelo: 0,
        idtpdoc: 0,
        cditem: '',
        nmitem: '',
        descricao: '',
        tporigem: 0,
        ativo: 'S',
        idlogin: 0,
    })
}
